import { parseFloatUniversal, roundOptionalDigits } from "./numberUtils";
var WakeUpIntervalDigits = 2;
export function calculateIntervalStringAndType(interval) {
    var intervalType;
    var intervalString;
    if (interval % intervalMultiplier(WakeupIntervalType.DAY) === 0) {
        intervalType = WakeupIntervalType.DAY;
        intervalString = roundOptionalDigits(interval / intervalMultiplier(WakeupIntervalType.DAY), WakeUpIntervalDigits).toString();
    }
    else if (interval % intervalMultiplier(WakeupIntervalType.HOUR) === 0) {
        intervalType = WakeupIntervalType.HOUR;
        intervalString = roundOptionalDigits(interval / intervalMultiplier(WakeupIntervalType.HOUR), WakeUpIntervalDigits).toString();
    }
    else {
        intervalType = WakeupIntervalType.MINUTE;
        intervalString = roundOptionalDigits(interval / intervalMultiplier(WakeupIntervalType.MINUTE), WakeUpIntervalDigits).toString();
    }
    return { intervalType: intervalType, intervalString: intervalString };
}
export function calculateRawIntervalValue(interval, intervalType) {
    var convertedInterval = parseFloatUniversal(interval);
    if (isNaN(convertedInterval)) {
        return null;
    }
    return convertedInterval * intervalMultiplier(intervalType);
}
export var minWakeUpIntervalSeconds = 4 * 60; //4 minutes
export var maxWakeUpIntervalSeconds = 7 * 24 * 60 * 60; //1 week
export function isAllowedInterval(intervalSeconds) {
    //for now scoped to GEN2 with static bounds.
    return intervalSeconds >= minWakeUpIntervalSeconds && intervalSeconds <= maxWakeUpIntervalSeconds;
}
// Multiplier for converting seconds into the supplied intervalType.
// For reverse calculating it can be used as divisor
function intervalMultiplier(intervalType) {
    switch (intervalType) {
        case WakeupIntervalType.MINUTE:
            return 60;
        case WakeupIntervalType.HOUR:
            return 3600;
        case WakeupIntervalType.DAY:
            return 86400;
    }
}
export function wakeUpIntervalTypeText(type, intl) {
    switch (type) {
        case WakeupIntervalType.MINUTE:
            return intl.formatMessage({ id: 'device.settings.wakeupinterval.minute' });
        case WakeupIntervalType.HOUR:
            return intl.formatMessage({ id: 'device.settings.wakeupinterval.hour' });
        case WakeupIntervalType.DAY:
            return intl.formatMessage({ id: 'device.settings.wakeupinterval.day' });
    }
}
export var WakeupIntervalType;
(function (WakeupIntervalType) {
    WakeupIntervalType[WakeupIntervalType["DAY"] = 0] = "DAY";
    WakeupIntervalType[WakeupIntervalType["HOUR"] = 1] = "HOUR";
    WakeupIntervalType[WakeupIntervalType["MINUTE"] = 2] = "MINUTE";
})(WakeupIntervalType || (WakeupIntervalType = {}));
/**
 * Convert TimeSpan string (HH:MM:SS) to seconds
 * @param timeSpan TimeSpan string (e.g., "00:50:00")
 * @returns number of seconds, or null if input is null/undefined
 */
export function convertTimeSpanToSeconds(timeSpan) {
    if (timeSpan == null)
        return null;
    if (!timeSpan)
        return 0;
    var parts = timeSpan.split(':');
    if (parts.length !== 3)
        return 0;
    var hours = parseInt(parts[0]) || 0;
    var minutes = parseInt(parts[1]) || 0;
    var seconds = parseInt(parts[2]) || 0;
    return (hours * 3600) + (minutes * 60) + seconds;
}
/**
 * Convert seconds to TimeSpan duration format (HH:MM:SS)
 * @param seconds number of seconds
 * @returns TimeSpan string (e.g., "00:04:00" for 240 seconds)
 */
export function convertSecondsToTimeSpan(seconds) {
    if (!seconds || seconds === 0)
        return "00:00:00";
    var hours = Math.floor(seconds / 3600);
    var minutes = Math.floor((seconds % 3600) / 60);
    var secs = seconds % 60;
    return "".concat(String(hours).padStart(2, '0'), ":").concat(String(minutes).padStart(2, '0'), ":").concat(String(secs).padStart(2, '0'));
}
